import { getModel } from '../../../model/registry'
import styled from 'styled-components'
import TabView from './TabView'
import DocumentDisplay from '../../generic/DocumentDisplay/DocumentDisplay'
import { useStore } from '../Page'
import useScreenSize from '../../../hooks/useScreenSize'
import { ResizeHandle, Panel, PanelGroup } from '../../resizable/Resizable'

const Wrapper = styled.div`
  margin: 0 0 -1rem -1rem;
`

const MainPanelInner = styled.div`
  padding: 1rem 0.5rem 1rem 1rem;
`

const SidePanelInner = styled.div`
  padding: 1rem;
  height: 100%;
  overflow-y: auto;
  border-left: 1px solid ${({ theme }) => theme.border?.default || '#e5e7eb'};
`

const resolvePanelContent = (panelConfig, storeData) => {
  if (panelConfig.content === 'DocumentDisplay') {
    return <DocumentDisplay data={storeData} />
  }
  return null
}

const CompositeView = ({ type, options }) => {
  const config = getModel('tabViewData')[type]
  const { isTablet } = useScreenSize()
  const [storeData] = useStore(s => s)

  const panel = config?.desktopPanel

  if (isTablet || !panel) {
    return <TabView type={type} options={options} />
  }

  const hasContent = panel.dataKey
    ? storeData?.[panel.dataKey]?.length > 0
    : true

  if (!hasContent) {
    return <TabView type={type} options={options} />
  }

  return (
    <Wrapper>
      <PanelGroup direction='horizontal'>
        <Panel defaultSize={62}>
          <MainPanelInner>
            <TabView type={type} options={options} />
          </MainPanelInner>
        </Panel>
        <ResizeHandle />
        <Panel defaultSize={38}>
          <SidePanelInner>
            {resolvePanelContent(panel, storeData)}
          </SidePanelInner>
        </Panel>
      </PanelGroup>
    </Wrapper>
  )
}

export default CompositeView
